import { render, staticRenderFns } from "./MembershipBenefits.vue?vue&type=template&id=4bfb3f6c&scoped=true&"
import script from "./MembershipBenefits.vue?vue&type=script&lang=js&"
export * from "./MembershipBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb3f6c",
  null
  
)

export default component.exports